<template>
  <div ref="textField">
    <div
      v-if="readonly || (!isEditing && isAllowEditingMode)"
      class="displayField"
      :class="{ readonly }"
      :tabindex="readonly ? -1 : 0"
      @keydown.enter="setEditMode($refs.textField)"
      @click="setEditMode($refs.textField)"
    >
      <label>{{ label }}</label>
      <p class="value mt-2">{{ formattedValue }}</p>
      <div class="editIcon" v-if="!readonly">
        <v-icon size="20px">mdi-pencil</v-icon>
      </div>
    </div>
    <v-text-field
      v-else
      v-bind="$attrs"
      :label="label"
      :value="value"
      v-on="$listeners"
      :outlined="outlined"
    />
  </div>
</template>

<script>
export default {
  name: 'AdsTextField',
  props: {
    outlined: {
      type: Boolean,
      default: true   // override the default value 'false' in v-text-field
    },
    readonly: {
      type: Boolean,
      default: false
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    isAllowEditingMode: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    value: {
      default: null
    },
    formatter: {
      type: Function,
      default: null
    },
    setEditMode: {
      type: Function,
      default: null
    }
  },
  computed: {
    formattedValue() {
      return this.formatter ? this.formatter(this.value) : this.value
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../styles/ads.scss';

.v-application .error--text {
  color: $ads-error-red !important;
  caret-color: $ads-error-red !important;
}

::v-deep div.error--text {
  color: $ads-error-red !important;
  caret-color: $ads-error-red !important;
}

::v-deep label.error--text {
  color: $ads-error-red !important;
  caret-color: $ads-error-red !important;
}

::v-deep button.error--text {
  color: $ads-error-red !important;
  caret-color: $ads-error-red !important;
}

::v-deep i.error--text {
  color: $ads-error-red !important;
  caret-color: $ads-error-red !important;
}

label {
  color: $ads-primary-blue;
  font-size: 1rem;
  font-weight: 700;
}
.value {
  min-height: 1rem;
  color: $ads-grey-01
}

.editIcon {
  position: absolute;
  top: 7px;
  right: 7px;
  display: none;
  &:focus {
    display: block;
    border: 2px solid $ads-navy;
  }
}

.displayField:not(.readonly) {
  position: relative;
  cursor: pointer;
  label {
    cursor: pointer;
  }
  &:hover,
  &:focus {
    background-color: $ads-grey-04;
    .editIcon {
      display: block;
    }
  }
}

.displayField.readonly {
  cursor: not-allowed;
  label {
    cursor: not-allowed;
  }
}

.isEditing .displayField {
  padding-top: 0px !important;
}
</style>
